import { useState, useEffect } from "react";
import axios from "axios";
import { API, ADMIN_SESSION_KEY } from "@/lib/constants";

export const getAdminSessionToken = () => sessionStorage.getItem(ADMIN_SESSION_KEY);

export const setAdminSessionToken = (token) => {
  if (token) {
    sessionStorage.setItem(ADMIN_SESSION_KEY, token);
  } else {
    sessionStorage.removeItem(ADMIN_SESSION_KEY);
  }
};

export const getAdminHeaders = () => {
  const token = getAdminSessionToken();
  return token ? { "X-Admin-Session": token } : {};
};

export const useAdminAuth = (navigate) => {
  const [authenticated, setAuthenticated] = useState(false);
  useEffect(() => {
    const check = async () => {
      try {
        const res = await axios.get(`${API}/admin/status`, { headers: getAdminHeaders() });
        if (!res.data?.authenticated) {
          navigate("/admin-login");
          return;
        }
        setAuthenticated(true);
      } catch {
        navigate("/admin-login");
      }
    };
    check();
  }, [navigate]);
  return authenticated;
};

export const formatDate = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleString("en-GB");
};
